import { render, staticRenderFns } from "./ChatConversation.vue?vue&type=template&id=567a3e1c&scoped=true&"
import script from "./ChatConversation.vue?vue&type=script&lang=ts&"
export * from "./ChatConversation.vue?vue&type=script&lang=ts&"
import style0 from "./ChatConversation.vue?vue&type=style&index=0&id=567a3e1c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567a3e1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/cypher.team.viz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('567a3e1c')) {
      api.createRecord('567a3e1c', component.options)
    } else {
      api.reload('567a3e1c', component.options)
    }
    module.hot.accept("./ChatConversation.vue?vue&type=template&id=567a3e1c&scoped=true&", function () {
      api.rerender('567a3e1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Chat/ChatConversation.vue"
export default component.exports